import { HttpStatusError } from '../errors';

export function expectOK(response: Response): Response {
    if (!response.ok) {
        throw new HttpStatusError(response, 'Expected 2xx HTTP status');
    }

    return response;
}
